import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const GeneralContainer = styled.div({
  display: 'flex',
})

export const Cont = styled.div(props => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
}))

export const SContDetail = styled.div(props => ({
  display: 'flex',
  marginTop: props.sub ? '0' : '1rem',
  flexDirection: 'column',

  '&>div:first-child': {
    marginLeft: 0,
    marginTop: '0px',
    flex: 1
  },

  '>div:first-child .toleft': {
    marginLeft: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },

  '&>div': {
    marginLeft: '0px',
    marginTop: '1rem',
    flex: 1
  },

  '@media only screen and (min-width: 600px)': {
    flexDirection: 'row',

    '&>div': {
      marginLeft: '1rem',
      marginTop: '0px',
      flex: 1
    },
  },

  '@media only screen and (min-width: 769px)': {
    flexDirection: 'row',

    '&>div': {
      marginLeft: '1rem',
      marginTop: '0px',
      flex: 1
    },
  },
}))

export const SectionContainer = styled.div({
  display: 'flex',
  borderRadius: '5px',
  flexDirection: 'column',
  overflow: 'hidden',

  'div.header': {
    display: 'flex',
    padding: '5px 10px',
    width: '100%',
    fontSize: '12px',
    fontWeight: 'bold',
    background: v.borderGray,
  },

  'div.body': {
    border: `solid 0.5px ${v.borderGray}`,
    padding: '10px',
    paddingTop: '0px',
    borderTop: 'none',
    borderRadius: '0px 0px 5px 5px',
  }
})